import {AnyAction} from 'redux';
import {each, isString, indexOf} from 'lodash';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

export function action<T>(type: String, payload?: T, callbacks?: FormOnSubmitHelpers<any>) {
   return {
      type,
      payload,
      callbacks,
   };
}
export interface Action<Payload = any, Callbacks = FormOnSubmitHelpers<any>> extends AnyAction {
   type: string;
   payload?: Payload;
   callbacks?: Callbacks;
}

export const asyncType = (name: String) => ({
   REQUEST: `${name}_REQUEST`,
   SUCCESS: `${name}_SUCCESS`,
   ERROR: `${name}_ERROR`,
   SAGA: `${name}_SAGA`,
});
export type AsyncType = ReturnType<typeof asyncType>;

export function handleAsyncActions<T>(
   _state: T,
   action: Action,
   types: any,
   options?: {exclude?: string[]}
) {
   let state = _state;

   if (options?.exclude && indexOf(options?.exclude, action.type) >= 0) {
      return state;
   }

   each(types, (type: string | AsyncType) => {
      if (isString(type)) return;

      if (action.type === type.REQUEST) {
         state = {
            ...state,
            isFetching: true,
            error: null,
         };
         return false;
      }

      if (action.type === type.ERROR) {
         state = {
            ...state,
            isFetching: false,
            error: action.payload,
         };
         return false;
      }

      if (action.type === type.SUCCESS) {
         state = {
            ...state,
            isFetching: false,
            error: null,
         };
         return false;
      }
   });
   return state;
}
